import React from "react";
import "./ResourceLoader.css";

const ResourceLoader = ({ message = "Hold on, polishing the details ✨" }) => {
  return (
     <div className="overlay">
      <div className="loader-box">
        <div className="spinner"></div>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default ResourceLoader;